/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Hsrm9Inputs */

const en__field_enum_icsrm_hsrm9 = /** @type {(inputs: _Field_Enum_Icsrm_Hsrm9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RheinMain University of Applied Sciences`)
};

const de__field_enum_icsrm_hsrm9 = /** @type {(inputs: _Field_Enum_Icsrm_Hsrm9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochschule RheinMain`)
};

/**
* | output |
* | --- |
* | "RheinMain University of Applied Sciences" |
*
* @param {_Field_Enum_Icsrm_Hsrm9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_hsrm9 = /** @type {((inputs?: _Field_Enum_Icsrm_Hsrm9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Hsrm9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_hsrm9(inputs)
	return de__field_enum_icsrm_hsrm9(inputs)
});
export { _field_enum_icsrm_hsrm9 as "_field_enum_ICSRM_HSRM" }